module.exports = __webpack_public_path__ + "img/9.af16bfb5.jpeg";